export default function EditorialMarquee({
  items = ["Expertise", "Precision", "Care", "Judgement", "Continuity"],
}) {
  const track = [...items, ...items, ...items];
  return (
    <div
      className="py-10 border-y border-navy-600/10 overflow-hidden bg-beige-100"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track font-serif text-4xl md:text-6xl text-navy-600/70 italic tracking-tight">
        {track.map((t, i) => (
          <span key={i} className="flex items-center gap-16">
            <span>{t}</span>
            <span className="text-brass-400 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
